const colors = {
  AQUAMARINE: '#288e3b',
  WHITE: '#FFF',
  BLACK: '#000',
  GREY: '#fcfdfe',
  PINKRED: '#fc3a52',
  DARKGREY: '#f2f2f2',
  DEEPGREY: '#2f2f2f',
  BLUE: '#00E1FF',
}

export default colors;